/** Parse an ISO timestamp to epoch millis, treating a *naive* string (no
 *  trailing "Z" and no ±hh:mm offset) as UTC rather than browser-local.
 *
 *  The backend is inconsistent: stored bars come back tz-aware ("...+05:30")
 *  while some rows (e.g. fill `filled_at`) are naive UTC. `Date.parse` reads a
 *  naive string as *local* time, which shifts it by the viewer's offset and
 *  misaligns fills against bars. Appending "Z" pins naive strings to UTC so
 *  both sides land on the same timeline. */
export function parseTs(ts: string): number {
  if (!ts) return NaN;
  const hasTz = ts.endsWith("Z") || /[+-]\d{2}:?\d{2}$/.test(ts);
  return new Date(hasTz ? ts : `${ts}Z`).getTime();
}
